module.exports = __webpack_public_path__ + "static/media/velour3B.4d196347.jpg";